module.exports = __webpack_public_path__ + "SP_SPT7-Cookie-79582a53706e141c9892b2e96467fa2f.png";